var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "152px",
    height: "73px",
    viewBox: "0 0 152 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy",
    transform: "translate(-468.000000, -148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(283.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-black",
    transform: "translate(185.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.252,21.32 L22.376,21.32 L22.376,16.016 L5.252,16.016 L5.252,5.772 L23.376,5.772 L23.376,0.52 L2.13162821e-14,0.52 L2.13162821e-14,36.868 L5.252,36.868 L5.252,21.32 Z M30.652,0.52 L30.652,31.616 L47.76,31.616 L47.76,36.868 L25.4,36.868 L25.4,0.52 L30.652,0.52 Z M77.036,18.668 C77.036,14.924 75.528,11.648 73.188,9.256 C70.744,6.812 67.364,5.304 63.776,5.304 C60.188,5.304 56.86,6.812 54.468,9.256 C52.076,11.648 50.568,14.976 50.568,18.668 C50.568,22.36 52.076,25.688 54.468,28.08 C56.86,30.524 60.188,32.032 63.776,32.032 C67.364,32.032 70.744,30.524 73.188,28.08 C75.528,25.688 77.036,22.412 77.036,18.668 Z M45.264,18.668 C45.264,13.52 47.396,8.892 50.672,5.512 C54,2.132 58.68,0 63.776,0 C68.924,0 73.552,2.132 76.932,5.512 C80.208,8.892 82.34,13.52 82.34,18.668 C82.34,23.816 80.208,28.444 76.932,31.824 C73.552,35.256 68.924,37.336 63.776,37.336 C58.68,37.336 54,35.256 50.672,31.824 C47.396,28.444 45.264,23.816 45.264,18.668 Z",
    id: "FLO",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.848,38.48 L69.848,67.184 L85.64,67.184 L85.64,72.032 L65,72.032 L65,38.48 L69.848,38.48 Z M100.664,45.728 L96.44,57.584 L104.792,57.584 L100.664,45.728 Z M110.696,72.032 L106.664,62.144 L94.616,62.144 C93.32,65.216 91.64,69.248 90.584,72.032 L85.352,72.032 L98.84,38 L102.392,38 L115.88,72.032 L110.696,72.032 Z",
    id: "LA",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,40 C119,55.5339806 119,64.1747573 119,65.9223301 C119,68.5436893 122.548387,70 125.129032,70 C127.709677,70 130,68.8349515 130,65.9223301 C130,63.0097087 130,43.0776699 130,42.038835 C130,41 131,40 134.16129,40 C137.322581,40 138,41 138,42.038835 C138,43.0776699 138,63.0097087 138,65.9223301 C138,68.8349515 140.612903,70 143.193548,70 C145.774194,70 149,68.8349515 149,65.9223301 C149,63.9805825 149,55.3398058 149,40",
    id: "Line-Copy-12",
    stroke: "#101010",
    strokeWidth: 5,
    strokeLinecap: "square",
    transform: "translate(134.000000, 55.000000) rotate(-90.000000) translate(-134.000000, -55.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,4 C86,19.5339806 86,28.1747573 86,29.9223301 C86,32.5436893 89.5483871,34 92.1290323,34 C94.7096774,34 97,32.8349515 97,29.9223301 C97,27.0097087 97,7.0776699 97,6.03883495 C97,5 98,4 101.16129,4 C104.322581,4 105,5 105,6.03883495 C105,7.0776699 105,27.0097087 105,29.9223301 C105,32.8349515 107.612903,34 110.193548,34 C112.774194,34 116,32.8349515 116,29.9223301 C116,27.9805825 116,19.3398058 116,4",
    id: "Line-Copy-16",
    stroke: "#101010",
    strokeWidth: 5,
    strokeLinecap: "square"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bb02bff99b6a0af93fdc72d6b1a1e938.svg";
export { ForwardRef as ReactComponent };